import styled, { css } from 'styled-components'
import { themeGet } from 'styled-system'
import ContinueButton from 'components/ContinueButton'
import { OutlinedButton } from 'secondstep-components'
import { RECENT_ACTIVITIES_STACKED_MEDIA } from '../constants'

export const RecentActivitiesPrimaryButton = styled(ContinueButton)`
  && {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 1;
    box-sizing: border-box;
    width: min(9.4375rem, 100%);
    min-width: 0;
    max-width: 100%;
    height: 1.9375rem;
    padding: 0.625rem min(1.25rem, 10%);
    border-radius: 0.9375rem;
    border: 2px solid ${themeGet('colors.elemDigital4')};
    background: ${themeGet('colors.elemDigital4')};
    background-color: ${themeGet('colors.elemDigital4')};
    color: ${themeGet('colors.white')};
    font-size: 1rem;
    font-family: ${themeGet('font.molde.medium')};
    text-transform: none;
    box-shadow: none;
  }

  && h5 {
    color: ${themeGet('colors.white')};
    font-size: 1rem;
    font-family: ${themeGet('font.molde.medium')};
    font-weight: normal;
  }

  &&:not([disabled]):hover {
    background: ${themeGet('colors.elemDigital5')};
    background-color: ${themeGet('colors.elemDigital5')};
    border-color: ${themeGet('colors.elemDigital5')};
    box-shadow: none;
  }

  &&:not([disabled]):hover h5 {
    color: ${themeGet('colors.white')};
  }
`

export const RecentActivitiesSecondaryButton = styled(OutlinedButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 1;
  box-sizing: border-box;
  width: min(9.4375rem, 100%);
  min-width: 0;
  max-width: 100%;
  height: 1.9375rem;
  padding: 0.625rem min(1.25rem, 10%);
  border-radius: 0.9375rem;
  border: 2px solid ${themeGet('colors.blue')};
  background-color: ${themeGet('colors.white')};
  color: ${themeGet('colors.blue')};
  font-size: 1rem;
  font-family: ${themeGet('font.molde.medium')};
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    background-color: ${themeGet('colors.white')};
    border-color: ${themeGet('colors.darkBlue')};
    color: ${themeGet('colors.darkBlue')};
  }
`

export const RecentActivitiesLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-shrink: 1;
  box-sizing: border-box;
  width: auto;
  min-width: 0;
  max-width: 100%;
  margin-top: 0.5rem;

  @media ${RECENT_ACTIVITIES_STACKED_MEDIA} {
    width: min(9.4375rem, 100%);
    justify-content: center;
    margin-top: 0;
  }
`

export const RecentActivitiesLink = styled.button.attrs({ type: 'button' })`
  appearance: none;
  display: inline;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  color: ${themeGet('colors.blue')};
  font-size: 1rem;
  font-family: ${themeGet('font.molde.medium')};
  text-align: inherit;
  text-decoration: none;
  cursor: pointer;
  white-space: nowrap;
  transition: color 0.2s ease;

  &:hover {
    color: ${themeGet('colors.darkBlue')};
  }
`

export const RecentActivitiesDoneStarIcon = styled.span`
  display: inline-flex;
  align-items: center;
  line-height: 0;

  svg path {
    fill: ${themeGet('colors.elemDigital1')};
  }
`

export const RecentActivitiesMetricContent = styled.div`
  min-width: 0;

  @media ${RECENT_ACTIVITIES_STACKED_MEDIA} {
    flex: 1;
  }

  ${({ isDone }) =>
    isDone &&
    css`
      margin-top: 0.5625rem;
    `}
`
